import {
  CrewClaimReasonCategoryCode as ClaimReasonCategoryCode,
  CrewClaimTypeEnum as ClaimType,
  corsoClaimTypeProgramName as ClaimTypeProgramName,
  corsoClaimTypeProgramPluralName as ClaimTypeProgramPluralName,
  CrewUi,
  CurrencyCode,
  geoCountryCodes as GeoCountryCodes,
  ClaimReasonEnum as GspClaimReason,
  CrewClaimResolutionMethodEnum as ResolutionMethod,
  ShipmentMethod as ReturnShipmentType,
  CrewClaimRollupStatusCode as RollupStatusCode,
} from 'corso-types';

export {
  ClaimReasonCategoryCode,
  ClaimType,
  ClaimTypeProgramName,
  ClaimTypeProgramPluralName,
  CurrencyCode,
  GeoCountryCodes,
  GspClaimReason,
  ResolutionMethod,
  ReturnShipmentType,
  RollupStatusCode,
};
export const CORSO_DEMO_REFERRER = 'corso-demo';
export const { OrderEditType } = CrewUi;
export const REFERRER_QUERY_PARAM = CrewUi.REF_QUERY_PARAM;
export const CORSO_URL = 'https://corso.com';
export const CORSO_LOGO_URL =
  'https://cdn.corso.com/img%2Fcrew-ui-corso-logo.svg';
export const CORSO_BOX_ICON_IMG_URL =
  'https://cdn.corso.com/img/Default%20box.png';

export const PRODUCT_NOT_FOUND_IMG_URL =
  'https://cdn.corso.com/img/image-not-available.jpeg';

export const ResolutionMethodLabels = {
  [ResolutionMethod.refund]: 'Refund',
  [ResolutionMethod.variantExchange]: 'Exchange',
  [ResolutionMethod.giftCard]: 'Gift Card',
  [ResolutionMethod.repair]: 'Repair',
  [ResolutionMethod.replacementOrder]: 'Replacement Order',
  [ResolutionMethod.warrantyReview]: 'Warranty',
  [ResolutionMethod.other]: 'Other',
} as const satisfies Record<ResolutionMethod, string>;

export const GspReasonLabels = {
  [GspClaimReason.damaged]: 'It was damaged',
  [GspClaimReason.stolen]: 'It was marked delivered but was never received',
  [GspClaimReason.lost]: 'It was lost in transit',
  [GspClaimReason.wrongItem]: 'I received the wrong item',
  [GspClaimReason.missingItem]: 'An item is missing from my order',
  [GspClaimReason.qualityIssue]: 'There is a quality issue with my item',
  [GspClaimReason.incorrectAddress]: 'The wrong address was used',
  [GspClaimReason.satisfactionGuarantee]:
    "I'm not satisfied with the quality of my item",
} as const satisfies Record<GspClaimReason, string>;

export const ClaimRollupStatuses = {
  [RollupStatusCode.inProgress]: 'Requested',
  [RollupStatusCode.readyForReview]: 'In Review',
  [RollupStatusCode.completed]: 'Completed',
} as const satisfies Record<RollupStatusCode, string>;

export const ExchangeMethod = {
  standard: 'standard',
  instant: 'instant',
} as const;

export type ExchangeMethod =
  (typeof ExchangeMethod)[keyof typeof ExchangeMethod];

export const exchangeMethodLabel = {
  [ExchangeMethod.instant]: 'Instant Exchange',
  [ExchangeMethod.standard]: 'Exchange',
} satisfies Record<ExchangeMethod, string>;

/**
 * iana top-level media types
 * @see https://www.iana.org/assignments/top-level-media-types/top-level-media-types.xhtml
 */
export enum MediaType {
  application = 'application',
  audio = 'audio',
  example = 'example',
  font = 'font',
  haptics = 'haptics',
  image = 'image',
  message = 'message',
  model = 'model',
  multipart = 'multipart',
  text = 'text',
  video = 'video',
}

export const RouteIds = {
  appShell: 'appShell',
  claimOverview: 'claimOverview',
} as const;
